import { SkeletonLoader, TableCell } from '@toggle/design-system';
import React from 'react';

import * as S from './LoaderCell.styles';

export const LoaderCell = ({ numberOfRows }: { numberOfRows: number }) => {
  return (
    <>
      {Array.from({ length: numberOfRows }).map((_, index) => {
        return (
          <tr key={`tr-${index}`} style={{ width: '100%' }}>
            <TableCell alignment="left">
              <S.RankLoaderWrapper>
                <SkeletonLoader
                  areas={[
                    {
                      styles: {
                        width: '100%',
                        height: '24px',
                        borderRadius: '8px',
                      },
                    },
                  ]}
                />
              </S.RankLoaderWrapper>
            </TableCell>
            <TableCell alignment="left">
              <S.FlexRow>
                <S.LogoLoaderWrapper>
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '32px',
                          borderRadius: '40px',
                        },
                      },
                    ]}
                  />
                </S.LogoLoaderWrapper>
                <S.ThemeNameLoaderWrapper $width={`${114 + index * 30}px`}>
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '24px',
                          borderRadius: '8px',
                        },
                      },
                    ]}
                  />
                </S.ThemeNameLoaderWrapper>
              </S.FlexRow>
            </TableCell>
            <TableCell alignment="left">
              <S.DescriptionLoaderWrapper>
                <SkeletonLoader
                  areas={[
                    {
                      styles: {
                        width: '100%',
                        height: '12px',
                        borderRadius: '8px',
                      },
                    },
                  ]}
                />
              </S.DescriptionLoaderWrapper>
            </TableCell>
          </tr>
        );
      })}
    </>
  );
};
